module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-16-09.468Z.3003c8d1.png";